import Button from "../Button";
import { trigger } from "controllers/EventManager";
import { useGame } from "context/GameContext";
import Debug from "debug";
const debug = Debug("components:Action");

const Action = (
  {
    title,
    type,
    execute,
    enabled,
    tooltips,
    cooldown,
    hotkey,
    isAccept,
    event,
    level = 0,
  },
) => {
  const { gameState, setGameState, setEvent, onDeath, addNotification } =
    useGame();
  const { party } = gameState;

  const onClick = (context) => {
    const { result, outcome, notification } = execute(context);
    debug(typeof title === "function" ? title(context) : title, result);

    // TODO: The output of actions needs to be more consistent and better structured
    if (result) setGameState((prev) => ({ ...prev, ...result }));
    if (outcome) {
      debug(type, outcome);
      if (outcome.eventTriggered) {
        if (!type) throw new Error("Action type is required to trigger event");
        trigger(type, outcome, context, setEvent);
      } else if (outcome.event) {
        setEvent(outcome.event(context, setEvent));
      } else if (outcome.isDead) {
        onDeath(outcome.step);
      }
    }
    if (notification) addNotification(notification);
  };

  return (
    <Button
      text={typeof title === "function" ? title(gameState) : title}
      forceDisabled={typeof enabled === "function"
        ? !enabled(gameState)
        : !enabled}
      onClick={() => onClick(gameState)}
      hasEvent={gameState.currentEvent && !event}
      tooltips={typeof tooltips === "function" ? tooltips(gameState) : tooltips}
      cooldown={cooldown}
      hotkey={hotkey}
      isAccept={isAccept}
      level={typeof level === "function" ? level({ party }) : 0}
    />
  );
};

export default Action;
